<template>
  <div class="cardPendency grid-2-g grid-4-m grid-12-s">
    <div class="column head">
      <div class="grid-12 row">
        <div class="grid-9 title">
          {{ pendency.pendencia }}
        </div>
        <div class="grid-3 row justify-end" title="Histórico de Pendências" @click="openHistoric(pendency)">
          <i class="fa fa-tasks" />
        </div>
      </div>
      <div class="grid-12 reason"><b>Motivo:</b> {{ pendency.motivo }}</div>
    </div>

    <div class="status">
      <b :class="status.replace(' ', '')">{{ status.replace("_", " ").toUpperCase() }}</b><br />
      {{ pendency.ajuda }}
    </div>

    <div class="row justify-center buttons align-end">
      <Button
        v-if="!pendency.operacao.includes('assinatura_contrato') && pendency.id_pendencia !== 13 && pendency.cta && pendency.status != 'paga'"
        :id="pendency.operacao" layout="green-dark" @click="solve(pendency)">RESOLVER</Button>
      <!-- CONTRATO -->
      <Button
        v-if="ready && pendency.operacao.includes('assinatura_contrato') && status != 'disponivel_download' && status != 'em_processamento' && status != 'assinado'"
        layout="green-dark" @click="solve(pendency)">RESOLVER</Button>
      <a v-if="pendency.id_pendencia == 13 && pendency.cta" href="/supporter/perfil">
        <Button layout="green-dark">RESOLVER</Button>
      </a>
      <div class="checkStatus row align-center" v-if="(!pendency.operacao.includes('assinatura_contrato') && pendency.status == 'paga' && pendency.id_pendencia != 2) ||
        (pendency.id_pendencia == 2 &&
          competence &&
          competence.competencias_selecionadas.length > 0 &&
          pendency.status == 'paga')
      ">
        <Avatar>
          <i class="fa fa-check"></i>
        </Avatar>
        <div class="solved">RESOLVIDO</div>
      </div>
      <div class="checkStatus row align-center"
        v-if="pendency.operacao.includes('assinatura_contrato') && (status == 'disponivel_download' || status == 'assinado')">
        <Avatar>
          <i class="fa fa-check"></i>
        </Avatar>
        <div class="solved">RESOLVIDO</div>
      </div>
      <!-- <div class="row align-center" v-if="pendency.status == 'reprovada' && pendency.id_pendencia != 2">
        <Avatar>
          <i class="fa fa-check"></i>
        </Avatar>
        <div class="reprovada"></div>
      </div> -->
    </div>

    <div class="link" v-if="pendency.operacao.includes('assinatura_contrato') && status == 'disponivel_download'"
      @click="solve(pendency)">
      Baixar Contrato</div>

    <div class="link" v-if="pendency.operacao == 'aceite_termo' && pendency.status == 'paga'" @click="solve(pendency)">
      Termos de uso</div>

    <div id="regras_conduta" class="link" v-if="pendency.operacao == 'aceite_regras' && pendency.status == 'paga'"
      @click="solve(pendency)">
      Regras e conduta</div>
    <Modal :modal="modal" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Button from "@/components/Button";
import Avatar from "@/components/Avatar";
import Modal from "@/components/Modal";
import Router from "@/router";

export default {
  name: "CardPendency",
  components: {
    Button,
    Avatar,
    Modal,
  },
  props: ["pendency"],
  data() {
    return {
      ready: false,
      historic: [],
      status: "",
      modal: {
        show: false,
        callback: () => {
          this.pendency.callback();
          this.modal.show = false;
        },
      },
      loader: true,
    };
  },
  methods: {
    ...mapMutations("user", ["SET_USER"]),
    ...mapActions("user", ["CLICKSIGN_CONTRATO"]),
    openHistoric(p) {
      this.modal.show = true;
      this.modal.layout = "Historic";
      this.modal.title = p.pendencia;
      this.modal.historic = p.historico;
    },
    solve() {

      // PIX
      if (this.pendency.operacao == "chave_pix") {
        this.modal.title = "Confirmar chave PIX";
        this.modal.layout = "ChavePix";
        this.modal.show = true;
        return;
      }

      // CONTRATO
      /*  if (this.pendency.operacao == "assinatura_contrato") {
         this.modal.title = "Assinatura Contrato";
         this.modal.layout = "Contrato";
         this.modal.show = true;
         return;
       } */

      // CONTRATO DIGITAL
      if (this.pendency.operacao.includes("assinatura_contrato")) {
        this.modal.title = "Assinatura Contrato Digital";
        this.modal.layout = "ContratoDigital";
        this.modal.show = true;
        return;
      }

      // TERMO
      if (this.pendency.operacao == "aceite_termo") {
        this.modal.layout = "Termo";
        this.modal.title = "Termos de uso";

        if (this.pendency.status == 'paga')
          this.modal.hideButton = this.pendency.dh_ult_atualizacao
        this.modal.show = true;
        return;
      }

      // TERMO SUPPORTER
      if (this.pendency.operacao == "aceite_termo_agregado_doutor") {
        this.modal.layout = "TermoSupporter";
        if (this.pendency.status == 'paga')
          this.modal.hideButton = this.pendency.dh_ult_atualizacao
        this.modal.show = true;
        return;
      }

      // COMPETENCIAS
      if (this.pendency.operacao == "competencia_doutor") {
        this.modal.tab = "comp";
        this.modal.layout = "CompCertTool";
        this.modal.show = true;
        return;
      }

      // FERRAMENTAS
      if (this.pendency.operacao == "ferramenta_doutor") {
        this.modal.tab = "tool";
        this.modal.layout = "CompCertTool";
        this.modal.show = true;
        return;
      }

      // CERTIFICADOS
      if (this.pendency.operacao == "certificado_doutor") {
        this.modal.tab = "cert";
        this.modal.layout = "CompCertTool";
        this.modal.show = true;
        return;
      }

      // COMPLETAR CADASTRO
      if (this.pendency.operacao == "atualizar_dados_pessoais") {
        Router.push("/supporter/perfil");
        return;
      }

      // APP
      if (this.pendency.operacao == "login_app") {
        this.modal.layout = "App";
        this.modal.show = true;
        return;
      }

      // REGRAS
      if (this.pendency.operacao == "aceite_regras") {
        this.modal.layout = "Regras";
        if (this.pendency.status == 'paga')
          this.modal.hideButton = this.pendency.dh_ult_atualizacao
        this.modal.show = true;
        return;
      }

      // SLACK
      if (this.pendency.operacao == "sync_slack") {
        this.modal.layout = "Slack";
        this.modal.show = true;
        return;
      }

      // DOC ID
      if (this.pendency.operacao == "identidade") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /*   this.modal.pendency = { tipo_arquivo: "1_id_doutor" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }

      // SELF COM DOC
      if (this.pendency.operacao == "self_identidade") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /*    this.modal.pendency = { tipo_arquivo: "4_self_doutor_doc" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;

        return;
      }

      // FOTO DOUTOR
      if (this.pendency.operacao == "foto_doutor") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /*  this.modal.pendency = { tipo_arquivo: "5_foto_doutor" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = (midia) => {
          this.user.link_foto_doutor = midia;
          this.SET_USER(this.user);
          this.pendency.callback();
          this.modal.show = false;
        };
        return;
      }

      // COMPROVANTE RESIDENCIA
      if (this.pendency.operacao == "comprovante_residencia") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /*  this.modal.pendency = { tipo_arquivo: "7_comprovante_residencia" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }

      // CERTIDAO POLICIA FEDERAL
      if (this.pendency.operacao == "cn_pf") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /*   this.modal.pendency = { tipo_arquivo: "3_ac_doutor_pf" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }
      // CERTIDAO POLICIA CIVIL
      if (this.pendency.operacao == "cn_pc") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /*     this.modal.pendency = { tipo_arquivo: "2_ac_doutor_pc" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }
      // COMPROVANTE BANCARIO
      if (this.pendency.operacao == "comprovante_bancario") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /* this.modal.pendency = { tipo_arquivo: "8_comprovante_bancario" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }

      // COMPROVANTE PJ
      if (this.pendency.operacao == "comprovante_pj") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /* this.modal.pendency = { tipo_arquivo: "11_comprovante_pj" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }

      // CURRICULO
      if (this.pendency.operacao == "curriculo") {
        this.modal.title = this.pendency.pendencia;
        this.modal.description = this.pendency.motivo;
        this.modal.layout = "Files";
        this.modal.show = true;
        /* this.modal.pendency = { tipo_arquivo: "12_curriculo" }; */
        this.modal.pendency = this.pendency;
        this.modal.cb = this.modal.callback;
        return;
      }

      // DOCUMENTOS
      if (this.pendency.operacao == "documentos")
        Router.push("/parceiro/documentos");

      // DADOS BANCARIOS
      if (this.pendency.operacao == "dados_bancarios")
        Router.push("/parceiro/pagamento");
    },
    updateContrato() {
      this.CLICKSIGN_CONTRATO({ op: this.pendency.operacao })
        .then(({ data }) => {
          if (data && data.status) {
            this.status = data.status
            this.modal.contrato = data
            this.modal.callback = this.updateContrato
            this.modal.operacao = this.pendency.operacao
            this.modal.id_pendencia = this.pendency.id
            this.ready = true
            this.$forceUpdate()
          }
        })
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
  beforeMount() {
    if (this.pendency.operacao.includes("assinatura_contrato")) this.updateContrato()
  },
  mounted() {
    const pag = this.$route.query.pagamento;
    if (pag) {
      let regras = document.getElementById("aceite_regras")
      setTimeout(() => {
        if (regras) regras.click()
        else document.getElementById("regras_conduta").click()
      }, 1000);
    }

  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.cardPendency {
  color: $gray-1;
  margin: 16px 21px;
  border-radius: 17px;
  background: white;
  border-right: 2px solid #ccc;
  border-bottom: 3px solid #ccc;
  padding-bottom: 0px;

  .head {
    padding: 16px 21px;
    padding-bottom: 0px;
    border-radius: 21px;
    overflow: auto;
    height: 100px;

    i {
      cursor: pointer;

      &:hover {
        color: $blue-1;
      }
    }

    .title {
      font-size: 17px;
      font-weight: bold;

      @media (max-width: $small) {
        font-size: 14px;
      }
    }

    .reason {
      font-size: 12px;
      color: $gray-5;
      margin-top: 9px;
      height: 35px;
      overflow: auto;
    }
  }

  .link {
    color: $purple;
    text-decoration: underline;
    margin: 8px 0;
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    font-weight: bold;

  }

  .status {
    padding: 0px 16px;
    font-size: 11px;
    text-align: center;

    b {
      text-transform: uppercase;
      font-size: 13px;
    }

    .pendente,
    .em_processamento,
    .assinado .aguardando_assinatura {
      color: $orange-1;
    }

    .emanalise,
    .disponivel_download {
      color: $purple;
    }

    .reprovada,
    .cancelado,
    .expirado {
      color: $red-1;
    }

    .pre-processamento {
      color: $gray-3;
    }
  }

  .buttons {
    padding: 16px 9px;
    padding-top: 0px;
    margin-top: 10px;
  }

  .solved {
    color: $purple;
    font-weight: bold;
    margin-left: -12px;
    margin-top: 4px;
    font-size: 14px;
  }

  &-empty {
    height: 45vh;

    &-text {
      margin-top: 28px;
      font-size: 18px;
      color: $font-color;
      text-align: center;
    }
  }

  &-loader {
    height: 35vh;
  }

  .content {
    color: $gray-1;
  }

  .checkStatus {
    margin-top: 8px;
  }

  .avatar {
    background: $purple;
    width: 28px;
    height: 26px;
    margin-right: 20px;
    box-shadow: none;
  }

  .button {
    font-size: 11px;
    max-height: 30px;
    margin-top: 19px;
    background: $red;
  }

  .modal {
    top: 80px;

    @media (max-width: $small) {
      width: 100%;
      left: 0px;
    }
  }

  .historic {
    padding: 30px;
    width: 600px;
    max-height: 400px;
    overflow-y: auto;

    @media (max-width: $small) {
      width: inherit;
    }

    .line {
      border-radius: 3px;
      padding: 12px 9px;

      &:nth-child(even) {
        background: $white-9;
      }
    }

    .title {
      font-weight: bold;
      height: 30px;
      color: $font-color;
      font-size: 14px;
    }
  }
}
</style>
